/* eslint-disable no-unused-vars */
// **  cognito helper
import { CognitoAuth } from "@contexts/auth/cognito"

// ** Amplify
import { API } from "aws-amplify"
// **  store names
import { STORES } from "@constants/redux"

// ** main app Logger
import { appLogger } from "@helpers/logger"

import { userRoles } from "@constants/system"
// ** constants
import { globalConst } from "@constants/global"

// ** system wide config
import systemConfig from "@configs/systemConfig"

// ** Acl subject,actions
import { AclSubjects, AclActions } from "@constants/acl"

// **  utility
import { isEmpty, drop } from "lodash"

/** users groups */
const GROUP = globalConst.auth.groups

// ** fuzzy search support
import Fuse from "fuse.js"
import { devLog } from "@helpers/devLog"

const shouldSkipProtectedDashboardCalls = () => {
  // Server-authoritative admin dashboard: disable local fallback mode.
  return false
}

const LOCAL_OWNERS_STORAGE_KEY = "admin_local_owners_v1"

const readLocalOwners = () => {
  if (typeof window === "undefined") return []
  try {
    const raw = window.localStorage.getItem(LOCAL_OWNERS_STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch (_error) {
    return []
  }
}

const writeLocalOwners = (items) => {
  if (typeof window === "undefined") return
  window.localStorage.setItem(
    LOCAL_OWNERS_STORAGE_KEY,
    JSON.stringify(Array.isArray(items) ? items : [])
  )
}

/** initla state for auth store  */
const initialState = {
  data: [],
  current: {},
  perPageValues: [5, 10, 25, 50],
  itemPerPage: 5,
  filters: {},
  message: "",
  keyword: null,
  action: globalConst.action.NONE
}

export const owners = {
  state: initialState,

  reducers: {
    /**
     * Set translate message
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setMessage: (s, payload) => {
      return {
        ...s,
        message: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setData: (s, payload) => {
      return {
        ...s,
        data: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    pushNewData: (s, payload) => {
      const can = Array.isArray(s.data) ? s.data : []
      return {
        ...s,
        data: [...can, payload]
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setFilters: (s, payload) => {
      return {
        ...s,
        filters: { ...s.filters, ...payload }
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setKeyword: (s, payload) => {
      return {
        ...s,
        keyword: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setitemPerPage: (s, payload) => {
      return {
        ...s,
        itemPerPage: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrent: (s, payload) => {
      return {
        ...s,
        current: payload
      }
    },

    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setAction: (s, payload) => {
      return {
        ...s,
        action: payload
      }
    }
  },
  selectors: (slice, createSelector) => ({
    /**
     *
     * @returns
     */
    error() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.stuffs],
        (stuffs, stuffsLoading) => {
          return stuffsLoading.error || ""
        }
      )
    },

    /**
     * success selector used in different
     * auth actions
     *
     * @returns {String}
     */
    success() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.owners],
        (owners, ownersLoading) => ownersLoading.success
      )
    },
    paginationData() {
      return createSelector([slice], (owners) => {
        if (!isEmpty(owners.filters)) {
          const role = owners.filters.role
          const status = owners.filters.status

          let data = !!role
            ? role !== userRoles.ALL.toLocaleLowerCase()
              ? owners.data.filter((e) => e.group === role)
              : owners.data
            : owners.data
          data = !!status
            ? status !== userRoles.ALL.toUpperCase()
              ? data.filter((e) => e.status === status)
              : data
            : data
          const offset = (owners.currentPage - 1) * owners.itemPerPage

          return drop(data, offset).slice(0, owners.itemPerPage)
        }
        if (!!owners.keyword) {
          const options = {
            keys: ["nickname", "name", "email"]
          }
          const fuse = new Fuse(owners.data, options)
          let data = fuse.search(owners.keyword)
          data = data.map((e) => e.item)
          const offset = (owners.currentPage - 1) * owners.itemPerPage
          return drop(data, offset).slice(0, owners.itemPerPage)
        }
        if (owners.data.length) {
          const offset = (owners.currentPage - 1) * owners.itemPerPage
          return drop(owners.data, offset).slice(0, owners.itemPerPage)
        }
        return owners.data
      })
    }
  }),
  effects: (dispatch) => ({
    /**
     *
     */
    async fetchOwners() {
      appLogger.info("fetchOwners", `[REDUX][${STORES.OWNERS}]`)
      this.setAction(globalConst.action.FETCH_OWNERS)
      if (shouldSkipProtectedDashboardCalls()) {
        this.setData(readLocalOwners())
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        const result = await API.get("prefsApiGateway", "/owners")

        this.setData(result)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setData([])
        this.setAction(globalConst.action.NONE)
        return
      }
    },
    /**
     *
     * @param {*} payload
     */
    async saveNewOwner(payload) {
      appLogger.info("saveNewOwner", `[REDUX][${STORES.OWNERS}]`)
      this.setAction(globalConst.action.ADD_NEW_OWNER)
      try {
        if (shouldSkipProtectedDashboardCalls()) {
          const newOwner = {
            ...payload,
            pk: `local-owner-${Date.now()}`
          }
          const next = [...readLocalOwners(), newOwner]
          writeLocalOwners(next)
          this.pushNewData(newOwner)
          this.setMessage("msg_owner_added_sucess")
          this.setAction(globalConst.action.NONE)
          return newOwner
        }
        const result = await API.post("prefsApiGateway", "/owners", {
          body: payload
        })
        const newOwner = {
          ...payload,
          pk: result.pk
        }
        this.pushNewData(newOwner)
        this.setMessage("msg_owner_added_sucess")
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setAction(globalConst.action.NONE)
        return
      }
    },

    /**
     *
     * @param {*} id
     */
    async disableOwner(id) {
      // devLog(payload)
      appLogger.info("disableOwner", `[REDUX][${STORES.OWNERS}]`)
      this.setAction(globalConst.action.DISABLE_OWNER)
      try {
        if (shouldSkipProtectedDashboardCalls()) {
          const next = readLocalOwners().map((owner) =>
            owner.pk === id ? { ...owner, status: false } : owner
          )
          writeLocalOwners(next)
          this.setData(next)
          this.setMessage("msg_owner_disabled")
          this.setAction(globalConst.action.NONE)
          return
        }
        const result = await API.del("prefsApiGateway", `/owners/${id}/status`)
        this.setMessage("msg_owner_disabled")
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setAction(globalConst.action.NONE)
        return
      }
    },
    /**
     *
     * @param {*} id
     */
    async enableOWner(id) {
      appLogger.info("enableOWner", `[REDUX][${STORES.OWNERS}]`)
      this.setAction(globalConst.action.ENABLE_OWNER)
      try {
        if (shouldSkipProtectedDashboardCalls()) {
          const next = readLocalOwners().map((owner) =>
            owner.pk === id ? { ...owner, status: true } : owner
          )
          writeLocalOwners(next)
          this.setData(next)
          this.setMessage("msg_owner_enabled")
          this.setAction(globalConst.action.NONE)
          return
        }
        const result = await API.put("prefsApiGateway", `/owners/${id}/status`)
        this.setMessage("msg_owner_enabled")
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setAction(globalConst.action.NONE)
        return
      }
    },

    /**
     *
     *
     */
    async getPresignedUrl(key) {
      appLogger.info("getPresignedUrl", `[REDUX][${STORES.OWNERS}]`)
      try {
        if (shouldSkipProtectedDashboardCalls()) {
          return { key }
        }
        const url = await API.post("prefsApiGateway", "/owners/upload", {
          key
        })
   
        //   this.setMessage("msg_owner_enabled")
      } catch (error) {
        return
      }
    },

    /**
     * Get owner by PK
     *
     * @param {*} id
     */
    async getOwner(id) {
      appLogger.info("getOwner", `[REDUX][${STORES.OWNERS}]`)
      this.setAction(globalConst.action.GET_OWNER)
      try {
        if (shouldSkipProtectedDashboardCalls()) {
          const owner = readLocalOwners().find((item) => item.pk === id) || {}
          this.setCurrent(owner)
          this.setAction(globalConst.action.NONE)
          return
        }
        const result = await API.get("prefsApiGateway", `/owners/${id}`)
        
        this.setCurrent(result)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setAction(globalConst.action.NONE)
        return
      }
    },
    /**
     *
     */
    onAcionReset() {
      this.setAction(globalConst.action.NONE)
    },
    /**
     *
     * @param {*} param0
     */
    resetCurrentRecord(payload = {}) {
      this.setCurrent(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onItemPerPageChange(payload) {
      this.setitemPerPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onFiltersChange(payload) {
      this.setFilters(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onKeywordChange(payload) {
      this.setKeyword(payload)
    }
  })
}
